var doResize = function doResize(el, binding, vnode) {
  // 获取虚拟节点组件对象
  var $table = vnode.componentInstance;
  // 获取绑定值（参数）
  var value = binding.value;
  if (!$table.height) {
    throw new Error("el-$table must set the height. Such as height='100px'");
  }
  var bottomOffset = value && value.bottomOffset || 20;
  if (!$table.data.length) return;
  var winH = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight;
  var height = winH - el.getBoundingClientRect().top - bottomOffset;
  // console.log('height', height)
  $table.layout.setHeight(height);
  $table.doLayout();
};
export default {
  bind: function bind(el, binding, vnode) {
    el.resizeListener = function () {
      // console.log('el.resizeListener')
      doResize(el, binding, vnode);
    };

    // addResizeListener(el, el.resizeListener)
    window.addEventListener('resize', el.resizeListener);
  },
  update: function update(el, binding, vnode) {
    // console.log(';update')
    doResize(el, binding, vnode);
  },
  unbind: function unbind(el) {
    // removeResizeListener(el, el.resizeListener)
    window.removeEventListener('resize', el.resizeListener);
  }
};